import { t } from "i18next";
import { useContext, useMemo } from "react";
import { AppContext } from "../App";
import { Actions, Subjects, useAuth } from "../hooks/useAuth";
import AppSubMenu from "./AppSubMenu";

const AppMenu = () => {
  const { checkUserPermission } = useAuth();
  const { currentEvent } = useContext(AppContext);

  const menuItems = useMemo(() => {
    if (currentEvent) {
      if (currentEvent?.virtual) {
        return [
          {
            label: `${currentEvent?.name}`,
            items: [
              {
                label: t("layout.appMenu.eventDetail.items.virtual.label"),
                icon: "pi pi-fw pi-globe",
                to: `/events/${currentEvent?.id}/virtual`,
                visible: checkUserPermission(Subjects.events, Actions.read),
              },
            ],
          },
        ];
      } else {
        return [
          {
            label: `${currentEvent?.name}`,
            items: [
              {
                label: t("layout.appMenu.eventDetail.items.dashboard.label"),
                icon: "pi pi-fw pi-globe",
                to: `/events/${currentEvent?.id}`,
                visible: checkUserPermission(Subjects.events, Actions.read),
              },
              {
                label: t(
                  "layout.appMenu.eventDetail.items.subscriptions.label",
                ),
                icon: "pi pi-fw pi-users",
                to: `/events/${currentEvent?.id}/subscriptions`,
                visible: checkUserPermission(
                  Subjects.subscriptions,
                  Actions.read,
                ),
              },
              {
                label: t("layout.appMenu.eventDetail.items.operators.label"),
                icon: "pi pi-fw pi-sitemap",
                to: `/events/${currentEvent?.id}/operators`,
                visible: checkUserPermission(Subjects.operators, Actions.read),
              },
            ],
          },
        ];
      }
    } else {
      return [
        {
          label: t("layout.appMenu.booking.label"),
          icon: "pi pi-th-large",
          items: [
            {
              label: t("layout.appMenu.booking.items.calendar.label"),
              icon: "pi pi-fw pi-calendar",
              to: "/calendar",
              visible:
                checkUserPermission(Subjects.availabilities, Actions.read) ||
                checkUserPermission(Subjects.bookings, Actions.read),
            },
            {
              label: t("layout.appMenu.booking.items.statistics.label"),
              icon: "pi pi-fw pi-chart-bar",
              to: "/statistics",
              visible: checkUserPermission(Subjects.statistics, Actions.read),
            },
            {
              label: t("layout.appMenu.booking.items.capabilities.label"),
              icon: "pi pi-fw pi-table",
              to: "/capabilities",
              visible: checkUserPermission(Subjects.capabilities, Actions.read),
            },
          ],
          visible:
            checkUserPermission(Subjects.availabilities, Actions.read) ||
            checkUserPermission(Subjects.bookings, Actions.read) ||
            checkUserPermission(Subjects.capabilities, Actions.read),
        },
        {
          label: t("layout.appMenu.eventsManagement.label"),
          icon: "pi pi-event",
          items: [
            {
              label: t("layout.appMenu.eventsManagement.items.events.label"),
              icon: "pi pi-fw pi-globe",
              to: "/events",
              visible: checkUserPermission(Subjects.events, Actions.read),
              items: [
                {
                  label: "",
                  icon: "pi pi-fw pi-globe",
                  to: "/events/:id",
                  visible: false,
                },
              ],
            },
          ],
          visible: checkUserPermission(Subjects.events, Actions.read),
        },
        {
          label: t("layout.appMenu.settings.label"),
          icon: "pi pi-gear",
          items: [
            {
              label: t("layout.appMenu.booking.items.courses.label"),
              icon: "pi pi-fw pi-book",
              to: "/courses",
              visible: checkUserPermission(Subjects.courses, Actions.read),
            },
            {
              label: t("layout.appMenu.settings.items.users.label"),
              icon: "pi pi-fw pi-sitemap",
              to: "/users",
              visible: checkUserPermission(Subjects.users, Actions.read),
            },
            {
              label: t("layout.appMenu.settings.items.places.label"),
              icon: "pi pi-fw pi-flag",
              to: "/places",
              visible: checkUserPermission(Subjects.places, Actions.read),
              items: [
                {
                  label: t(
                    "layout.appMenu.settings.items.places.items.placeDetail.label",
                  ),
                  icon: "pi pi-fw pi-globe",
                  to: "/places/:id",
                  visible: false,
                  makeParentActive: true,
                },
              ],
            },
            {
              label: t("layout.appMenu.settings.items.students.label"),
              icon: "pi pi-fw pi-users",
              to: "/students",
              visible: checkUserPermission(Subjects.students, Actions.read),
            },
            {
              label: t("layout.appMenu.settings.items.middlewareCalls.label"),
              icon: "pi pi-fw pi-server",
              to: "/middleware-calls",
              visible: checkUserPermission(
                Subjects.middlewareCalls,
                Actions.read,
              ),
            },
          ],
          visible:
            checkUserPermission(Subjects.users, Actions.read) ||
            checkUserPermission(Subjects.courses, Actions.read),
        },
      ];
    }
  }, [currentEvent, checkUserPermission]);

  return <AppSubMenu items={menuItems} />;
};

export default AppMenu;
